import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCurrencyCircle = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.04167 11.1806C6.04167 12.2544 6.91222 13.125 7.98611 13.125H9.79167C10.9423 13.125 11.875 12.1923 11.875 11.0417C11.875 9.89107 10.9423 8.95833 9.79167 8.95833H8.125C6.97441 8.95833 6.04167 8.02559 6.04167 6.875C6.04167 5.72441 6.97441 4.79167 8.125 4.79167H9.93056C11.0044 4.79167 11.875 5.66222 11.875 6.73611M8.95833 3.54167V4.79167M8.95833 13.125V14.375M17.2917 8.95833C17.2917 13.5607 13.5607 17.2917 8.95833 17.2917C4.35596 17.2917 0.625 13.5607 0.625 8.95833C0.625 4.35596 4.35596 0.625 8.95833 0.625C13.5607 0.625 17.2917 4.35596 17.2917 8.95833Z",
		stroke: "#0064FA",
		strokeWidth: 1.25,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCurrencyCircle;
